import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ActiveSiteIdResolver implements Resolve<string | null> {
  resolve(route: ActivatedRouteSnapshot): string | null {
    return route.params['activeSiteId'];
  }
}
